import { render, staticRenderFns } from "./team.vue?vue&type=template&id=28829ebf&scoped=true&"
import script from "./team.vue?vue&type=script&lang=js&"
export * from "./team.vue?vue&type=script&lang=js&"
import style0 from "./team.vue?vue&type=style&index=0&id=28829ebf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28829ebf",
  null
  
)

export default component.exports